module.exports = __webpack_public_path__ + "img/39.988fd342.png";